import axios from 'axios';
import apisUrls from '../urls';

const getSingleWebsiteServiceApi = (filterObj) => {
  return axios.get(apisUrls?.getSingleWebsiteServiceUrl(filterObj));
};

export default getSingleWebsiteServiceApi;
